<script setup lang="ts">
import { useRouter } from 'vue-router'
import TariffsInterface from '@/components/tariffs/TariffsInterface.vue'
import SupportButton from '@/components/support-button/SupportButton.vue'
import { ERouteNames } from '@/router/ERouteNames'
import { useAuthStore } from '@/modules/auth/stores/authStore'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const authStore = useAuthStore()
const { t } = useI18n()

const goToAuth = () => router.push({ name: ERouteNames.AUTH })
</script>

<template>
  <div class="guest-interface d-flex flex-column ga-4 w-100">
    <tariffs-interface />
    <template v-if="!authStore.isAuth">
      <div class="guest-interface__actions d-flex flex-column ga-2">
        <v-btn
          variant="outlined"
          color="success"
          rounded="lg"
          block
          prepend-icon="ri-login-box-line"
          @click="goToAuth"
        >
          {{ t('auth.login') }}
        </v-btn>
        <support-button />
      </div>
    </template>
  </div>
</template>
